<!--
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-11-04 08:06:21
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2025-09-15 16:29:34
 * @FilePath: \PH2-Public\src\view\apply\child\selectPage.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="form-area">
    <div class="form-title">
      如因提交錯誤個人資料以致申請失敗，本會恕不負責，請小心填寫。</br>
      If the application fails due to the submission of the wrong personal data, we will not be responsible for it.
      Please fill out carefully.
    </div>

    <div class="center-label">
      申請方式* <br>
      Application method
    </div>

    <div class="apply-btn">
      <el-button type="warning" @click="onePersonApply">一人申請 (1 人單位或 3 人共居單位) </br> One-person application (One-person
        unit
        or
        three-person co-living unit) </el-button>
    </div>

    <div class="apply-btn">
      <el-button type="warning" @click="twoPersonApply">二人申請(2 人單位) </br>Two-person application (Twin or disabled unit)
      </el-button>
    </div>

    <div class="line" />

    <div class="ft-text">
      每人只可選擇其中一項申請方式 </br> Each person can choose only one of the application methods </br></br>

      一人申請適合申請單人單位或 3 人共居單位</br> The One-person application is suitable for applying for a single unit or a co-living unit for three
      </br></br>

      二人申請只供申請 2 人單位(亦可供傷健人士入住)</br> The Two-person applications are only for twin or disabled units. (which can also accommodate individuals with disabilities).
    </div>


  </div>
  </div>
</template>

<script>
export default {
  methods: {
    onePersonApply() {
      this.Session.set('formId',1);
      this.Session.set('formName',"");//formName','每人只可選擇其中一項申請方式Each person can choose either one of the application methods only 一人申請適合申請單人單位或 3 人共居單位 One-person application is suitable for applying the single unit or co-living unit for 3.
      this.$store.dispatch("NEXT_STEP", {
        changeStep: true,
        operateName: "personalInfo",
      });
    },
    twoPersonApply() {
       this.Session.set('formId',2);
      this.Session.set('formName',"");//二人申請只供申 2 人單位(亦可供傷健人士入住)Two-person application is only for Twin or disable unit.
      this.$store.dispatch("NEXT_STEP", {
        changeStep: true,
        operateName: "personalInfo",
      });
    },
  },
};
</script>

<style>
.center-label {
  height: 56px;
  padding: 10px 5px;
  font-weight: 500;
  line-height: 28px;
  font-size: 14px;
}

.apply-btn {
  padding: 20px 5px;
}

.ft-text {
  color: #737b7d;
  font-weight: 500;
  line-height: 18.15px;
  margin-top: 62px;
}
</style>



// WEBPACK FOOTER //
// src/view/apply/child/selectPage.vue